/**
 * The collection of of static content used in the application
 */
export const eStrings = {
  TXT_BEDRIJF_GEEN_GEPUBLICEERD_BESLUIT:
    'Dit bedrijf heeft nog geen gepubliceerd besluit',
  LBL_BEDRIJFSINFORMATIE_BEWERKEN: 'Bedrijfsinformatie bewerken',
  LBL_BEKIJK_ALLE_BESLUITEN: 'Bekijk alle besluiten en wijzigingen',
  LBL_BESLUITDATUM: 'Besluitdatum',
  TITEL_BESLUIT_IN_ONTWERP: 'Besluit in ontwerp',
  LBL_BESLUIT_KENMERK: 'Besluit kenmerk',
  TXT_BESLUIT_TYPES_LADEN: 'Besluit types laden...',
  TXT_BESLUIT_TYPES_SELECTEREN: 'Selecteer het type',
  TXT_DATE_FORMAT: 'dd-mm-jjjj',
  LBL_FEEDBACK_NEW_AADV_LOADED: 'Nieuwe vigerende situatie ingeladen',
  LBL_BESLUITEN_EN_WIJZIGINGEN: 'Besluiten & wijzigingen',
  LBL_INWERKINGTREDING: 'Inwerkingtreding',
  LBL_INLOGPAGINA_TITEL: 'Inloggen Digi-V®',
  TXT_INLOGPAGINA_SUBTITEL:
    'Welkom bij Digi-V®, de online omgeving voor het opstellen, bewerken en beheren van vergunningen.',
  LBL_BESLUIT_OMSCHRIJVING: 'Omschrijving',
  TXT_LOADING: 'Laden...',
  TXT_MBIO_WARNING:
    'Er is een ander besluit in ontwerp. Dat houdt in dat bepaalde onderdelen misschien niet aan te passen zijn. Dit geldt ook voor aanpassingen die in dit besluit worden gemaakt.',
  TXT_SELECT_BESLUITTYPE: 'Selecteer een type besluit',
  LBL_STATUS: 'Status',
  TXT_SELECT_STATUS: 'Selecteer een status',
  LBL_TYPE_BESLUIT: 'Type Besluit',
  LBL_TYPE_WIJZIGING: 'Type wijziging',
  LBL_VIGERENDE_SITUATIE: 'Vigerende situatie',
  TXT_VIGERENDE_SITUATIE:
    'De vigerende situatie laat alle geldige voorschriften zien van een specifieke datum. Deze voorschriften zijn afkomstig uit alle besluiten die zijn genomen voor ',
  TXT_VOORLOPIGE_VOORZIENING: 'Dit voorschrift is een voorlopige voorziening',
  TXT_BEROEP_INGEDIEND: 'Voor dit voorschrift is een beroep ingediend',
  LBL_DIGI_V: 'Digi-V®',
  LBL_EMAIL: 'digi-v@pzh.nl',
  LBL_CONSIDERANS: 'Inhoudelijke overwegingen',
  LBL_ZAAKNUMMER: 'Zaaknummer',
  TXT_VUL_ZAAKNUMMER: 'Vul een zaaknummer in',
  TXT_VERPLICHT_INPUT_VELD: 'Dit veld is verplicht',
  TXT_DISCLAIMER:
    'Hoewel bij de samenstelling van de inhoud van Digi-V® de grootst mogelijke zorgvuldigheid wordt betracht, bestaat de mogelijkheid dat bepaalde informatie (na verloop van tijd) verouderd is of om andere redenen toch niet correct of volledig is. Er kunnen op geen enkele wijze rechten aan Digi-V® worden ontleend. De uitvoerende omgevingsdienst aanvaardt geen aansprakelijkheid voor de eventuele schade die zou kunnen voortvloeien uit het gebruik van gegevens uit Digi-V®.',
  TXT_OPMERKINGEN_DELETE_WARNING:
    'Let op: deze actie zorgt ervoor dat alle opmerkingen onder dit object worden verwijderd.',
  TXT_CASCADE_DELETE_WARNING:
    'Let op, deze actie zorgt ervoor dat alle opmerkingen en bewerkingen onder dit object worden verwijderd.',
  LBL_CONFIRM_CASCADE_DELETE:
    'Ik begrijp dat opmerkingen en bewerkingen onder dit object worden verwijderd.',
} as const;

/**
 * Export the strings collection as optimized enum
 */
export type eStrings = (typeof eStrings)[keyof typeof eStrings];
